module.exports = __webpack_public_path__ + "static/media/19.b7308210.jpeg";